(function () {
	async function handleResponse(response, section) {
		const responseText = await response.text();
		const html = document.createElement('div');
		html.innerHTML = responseText;

		const sourceSlider = html.querySelector('.products-slider--search-perfomed');
		const targetWrapper = section.querySelector('.products-slider');

		if (!sourceSlider || !targetWrapper) {
			section.classList.add('products-slider-section--empty');
			return;
		}

		targetWrapper.innerHTML = sourceSlider.innerHTML;
	}

	function initSwiper(section) {
		const swiperEl = section.querySelector('.js-products-slider-swiper');
		if (!swiperEl) return;

		const sectionId = swiperEl.dataset.sectionId;
		const perView = parseInt(swiperEl.dataset.perView, 10) || 4;

		const prev = section.querySelector('.js-products-slider-prev');
		const next = section.querySelector('.js-products-slider-next');
		const scrollbar = section.querySelector('.js-products-slider-scrollbar');

		const breakpoints = {};

		if (perView >= 2) {
			breakpoints[576] = { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 24 };
		}
		if (perView >= 3) {
			breakpoints[990] = { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 };
		}
		if (perView >= 4) {
			breakpoints[1100] = { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 };
		}
		if (perView >= 5) {
			breakpoints[1360] = { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 24 };
		}
		if (perView >= 6) {
			breakpoints[1600] = { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 24 };
		}

		// Ordine casuale (impostazione "Casuale" dello slider)
        if (swiperEl.dataset.shuffle === 'true') {
            const list = swiperEl.querySelector('.swiper-wrapper');
            const slides = Array.from(list.children);
            for (let i = slides.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [slides[i], slides[j]] = [slides[j], slides[i]];
            }
            const max = parseInt(swiperEl.dataset.max, 10) || slides.length;
            slides.forEach((slide, i) => {
                if (i < max) list.appendChild(slide);
                else slide.remove();
            });
        }

        const swiperInstance = new Swiper(swiperEl, {
			slidesPerView: 1.2,
			spaceBetween: 20,
			slidesOffsetAfter: 20,
			navigation: {
				prevEl: prev,
				nextEl: next,
			},
			scrollbar: {
				el: scrollbar,
				draggable: true,
			},
			breakpoints: breakpoints,
		});
	}

	const initSection = async (section, retryCount = 0) => {
		if (!section || !section.classList.contains('section-products-slider')) return;

		const box = section.querySelector('.products-slider');
		if (!box) return;

		const isDynamicLoad = box.dataset.isDynamicLoad === 'true';
		const collectionUrl = box.dataset.collectionUrl;
		const loadingEl = box.querySelector('.loading-overlay');

		if (isDynamicLoad && collectionUrl && collectionUrl !== 'none') {
			box.classList.add('products-slider--loading');

			try {
				const response = await fetch(collectionUrl);
				if (response.status === 404 && retryCount === 0) {
					await new Promise((resolve) => setTimeout(resolve, 500));
					return initSection(section, retryCount + 1);
				}
				await handleResponse(response, section);
			} catch (error) {
				console.error('Error when fetching products:', error);
				section.classList.add('products-slider-section--empty');
			} finally {
				box.classList.remove('products-slider--loading');
				if (loadingEl) loadingEl.remove();
			}
		} else {
			box.classList.remove('products-slider--loading');
			if (loadingEl) loadingEl.remove();
		}

		initSwiper(section);
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target);
	});
})();
